import { FC } from 'react';

import { Loading } from 'ui/partials/PagePlaceholder/PagePlaceholder';
import { cn } from 'utils/helpers';

interface PROPS {
  className?: string;
}

const _Loading: FC<PROPS> = ({ className }) => (
  <div
    className={cn(
      'content-height-full flex items-center justify-center',
      className,
    )}
  >
    <Loading
      iconType="loading"
      title="loading"
      backButtonText=""
      description=""
    />
  </div>
);

export default _Loading;
